require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var Handlebars = require('handlebars');

var EmptyMonitorView = require('./empty_monitor.view.ts');
var QueueCountersMonitorView = require('./queue_counters_monitor.view.ts');
var QueueMonitorOneView = require('./queue_monitor_one.view.ts');
var QueueMonitorTwoView = require('./queue_monitor_two.view.ts');
var QueueMonitorMultipleView = require('./queue_monitor_multiple.view.ts');

var Collection = require('../../models/monitors.paginated.collection.ts');
var Pagination = require('../../views/pagination.view.ts');
var SockJS = require('sockjs-client');
var Stomp = require('stompjs');
require('dhtmlxMessage');
var i18n = require('l10n');

require('../../../libs/jquery-dynamicFontSize/jquery-dynamicFontSize.js');

var TheView = Backbone.View.extend({
	interval: null,
    collection: null,
    wsocket: null,
    autoRefreshTimer: null,
    callPatientBuffer: [],
    monitorView: null,
    emptyMonitorView: null,
    queueCountersMonitorView: null,
    queueMonitorOneView: null,
    queues: [],
    cleanupInterval: null,
    intervalTimes: {
        "el": 10000,
        "en": 3000
    },
	initialize: function (options) {
		var self = this;
		this.queueIds = options.queueIds;

        this.callPatientBuffer = [];

		$(window).off("popstate").on("popstate", function() {
		    if(self.autoRefreshTimer)
		        clearTimeout(self.autoRefreshTimer);
		    self.clearListener();
		});

        this.collection = new Collection();
        this.collection.url = '/rest/monitors/multiQueues?ids='+ encodeURIComponent(self.queueIds);
        this.collection.on( 'sync', this.successMonitorsData, this );
        this.collection.on( 'error', this.errorMonitorsData, this );

        this.setupAudio();

        this.collection.getFirstPage();

        if(this.autoRefreshTimer)
            clearTimeout(this.autoRefreshTimer);

        this.clearListener();
        this.setListener();
        if(!this.isSamsungBrowser) {
            this.startPeriodicCleanup();
        }
	},
    startPeriodicCleanup: function() {
        var self = this;
        if (this.cleanupInterval) {
            clearInterval(this.cleanupInterval);
        }
        this.cleanupInterval = setInterval(function() {
            self.cleanup();
        }, 3600000);
    },
    cleanup: function() {
        if (this.audioTimeout) {
            clearTimeout(this.audioTimeout);
        }
        if (this.callPatientAudio) {
            this.callPatientAudio.pause();
            this.callPatientAudio.currentTime = 0;
        }
        this.callPatientBuffer = [];
        console.log("Cleared!!! at " + new Date().toLocaleString());
    },
	successMonitorsData: function() {
	    this.queues = this.collection.models.map(x => x.attributes);
        this.prepareToRender(this.queues);

        if( this.monitorView instanceof QueueMonitorMultipleView) {
            var currentPage = this.collection.state.currentPage + 1;
            var totalPages = this.collection.totalPages;
            this.monitorView.refreshPagination(currentPage, totalPages);
        }

	},
	errorMonitorsData: function(response) {


    },
	prepareToRender: function(queuesArr) {
        var self = this;
        console.log("QUEUES >>>>", this.queues );

        if(this.monitorView != null) {
            this.monitorView.destroy();
        }

        this.monitorView = this.getMonitorView(queuesArr);

        clearTimeout(this.autoRefreshTimer);

        var isCounterView = (this.monitorView instanceof QueueCountersMonitorView);
        if (!isCounterView) {
            this.startAutoRefreshTimer();
        }

        this.postDataToView(queuesArr);

	},
	postDataToView: function(collection) {
	    this.monitorView.data(collection);

	},
	getMonitorView: function(queuesArr) {
	    //console.log('GETMONITORVIEW() >>> QUEUES \n', queuesArr)

	    if (this.collection.totalPages > 1 ) {
	        return this.getQueueMonitorMultipleView()
	    }

	    if(queuesArr.length == 0) {
	        return this.getEmptyMonitorView();
        }

        if (queuesArr.length == 2) {
            return this.getQueueMonitorTwoView();
        }

        if (queuesArr.length > 2) {
            return this.getQueueMonitorMultipleView();
        }

        if ((queuesArr[0].queue.type == "COUNTER" || queuesArr[0].queue.type == "EXAMINATION_CHAMBER") && !this.checkIfOnlyOneCounterIsOpen(queuesArr[0]) ) {
            return this.getQueueCountersMonitorView();
        }

        return this.getQueueMonitorOneView();
    },
	getEmptyMonitorView: function() {
        if (this.emptyMonitorView == null) {
            this.emptyMonitorView = new EmptyMonitorView();
        }

        return this.emptyMonitorView;

    },
	getQueueMonitorOneView: function() {
        if (this.queueMonitorOneView == null) {
            this.queueMonitorOneView = new QueueMonitorOneView();
        }

        return this.queueMonitorOneView;

    },
    getQueueMonitorTwoView: function() {
        if (this.queueMonitorTwoView == null) {
            this.queueMonitorTwoView = new QueueMonitorTwoView();
        }

        return this.queueMonitorTwoView;

    },
    getQueueMonitorMultipleView: function() {
        if (this.queueMonitorMultipleView == null) {
            this.queueMonitorMultipleView = new QueueMonitorMultipleView();
        }

        return this.queueMonitorMultipleView;
    },
	getQueueCountersMonitorView: function() {
	    if (this.queueCountersMonitorView == null) {
            this.queueCountersMonitorView = new QueueCountersMonitorView();
        }

        return this.queueCountersMonitorView;
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
        var self = this;
		this.superRender();
		this.isRenderCallAgain = true;

	},
    setupAudio: function() {
        var self = this;

        this.callPatientAudio = $("#callPatient-audio")[0];
        $(this.callPatientAudio).prop("volume", 1);
        $(this.callPatientAudio)[0].muted = false;
        this.callPatientAudio.loop = false;

        this.callPatientAudio.removeEventListener("ended", this.audioEndedHandler);
        this.callPatientAudio.removeEventListener("play", this.audioPlayHandler);

        this.audioEndedHandler = function(){
            self.callPatientAudio.currentTime = 0;
            self.callPatientAudio.pause();
            console.log("Audio playback ended");
        };
        this.callPatientAudio.addEventListener("ended", this.audioEndedHandler);

       this.audioPlayHandler = function(){
           console.log('Audio started playing');

           self.calculateAudioDuration().then(function(duration) {

               self.hasEnded = false;
               console.log('self.hasEnded', self.hasEnded);
               if (self.audioTimeout) {
                  clearTimeout(self.audioTimeout);
               }
               console.log('Promise duration:', self.callPatientAudio.duration);
               console.log('Audio duration on play:', duration);

               if (self.isSamsungBrowser()) {
                   console.log("Samsung device detected, using alternative playback method");
                    if (self.audioTimeout) {
                      clearTimeout(self.audioTimeout);
                   }

                   var checkInterval = 100;
                   var startTime = Date.now();

                   var checkAudioProgress = function() {
                       var currentTime = Date.now();
                       var elapsedTime = (currentTime - startTime) / 1000;

                       if (elapsedTime >= duration) {
                            if (!self.hasEnded) {
                               self.hasEnded = true
                               self.callPatientAudio.pause();
                               self.callPatientAudio.currentTime = 0;
                               console.log("Audio playback force stopped");
                           }
                       } else {
                           self.audioTimeout = setTimeout(checkAudioProgress, checkInterval);
                       }
                   };

                   self.callPatientAudio.onended = function() {
                       self.hasEnded = true;
                       console.log("Audio ended naturally");
                   };

                   self.audioTimeout = setTimeout(checkAudioProgress, checkInterval);

               } else {
                   self.audioTimeout = setInterval(function() {
                       if (self.callPatientAudio.currentTime >= duration ) {
                           self.callPatientAudio.pause();
                           self.callPatientAudio.currentTime = 0;
                           console.log("Audio playback stopped (setInterval check)");
                           clearInterval(self.audioTimeout);
                       }
                   }, 100);
               }

          });
       };

        this.callPatientAudio.addEventListener("play", this.audioPlayHandler);
        this.setupCallPatientAudio();
    },
    calculateAudioDuration() {
        var self = this;
        return new Promise((resolve) => {
            if (self.callPatientAudio.readyState > 0) {
                resolve(self.callPatientAudio.duration);
            } else {
                self.callPatientAudio.addEventListener("loadedmetadata", function() {
                    resolve(self.callPatientAudio.duration);
                });
            }
        });
    },
    setupCallPatientAudio: function() {
        var self = this;

        this.off("add:patientCall").on("add:patientCall", function() {

            var playNextPatient = function(soundData) {
                var src = soundData;
                self.callPatientAudio.setAttribute('src', src);

                self.callPatientAudio.load();

                self.callPatientAudio.muted = false;

                self.callPatientAudio.play();
            }

            var interval = null;

            var checkAndCall = function() {

                if(self.callPatientBuffer.length == 0) {
                    if(interval)
                        clearInterval(interval);

                    return;
                }
                var isPlaying = !self.callPatientAudio.paused || (self.callPatientAudio.currentTime != null && self.callPatientAudio.currentTime > 0);

                if(isPlaying) {
                    interval = setInterval(function() {
                        checkAndCall();
                    }, 2000);
                }
                else {
                    if(interval)
                        clearInterval(interval);

                    var patientData = self.getPatientToCall();

                    playNextPatient(patientData.soundData);
                }
            }

            checkAndCall();
        });
    },
    getPatientToCall: function() {

        var customSortByTimestamp = function(a,b) {
            if (a.timestamp > b.timestamp)
            {
                return 1;
            }
            else if (a.timestamp < b.timestamp)
            {
                return -1;
            }
            return 0;
        }

        this.callPatientBuffer = this.callPatientBuffer.sort(customSortByTimestamp);
        return this.callPatientBuffer.pop();
    },
    startAutoRefreshTimer: function() {
        var self = this;

        var intervalTime = this.intervalTimes[i18n.lng()];
        this.autoRefreshTimer = setTimeout(function() {
            self.checkLangAndGetNextPage();
        }, intervalTime);
    },
    checkLangAndGetNextPage: function() {
        var self = this;

        var isLastPage = this.collection.state.currentPage == this.collection.state.lastPage; // isLastPage can be in two occasions: 1) only one page, 2) last page of the iteration
        var hasNextPage = this.collection.state.currentPage < this.collection.state.lastPage;

        if (!hasNextPage) {
            this.toggleLanguage();
            this.collection.getFirstPage();
        } else {
            this.collection.getNextPage();
        }

        this.startAutoRefreshTimer();

    },
	setListener: function() {
		var self = this;
        this.clearListener();

		this.wsocket = new SockJS('rest/live');
		this.client = Stomp.over(this.wsocket);

		var headers = {
			//origin: 'https://www.qedis.com', toDo: enable it
		};

		this.client.connect(headers, function(frame) {
		    self.client.subscribe('/live/monitors/queues/multi', function (message){
		        var jsonResponse;

		        try {
		            jsonResponse = JSON.parse(message.body);

		            if (jsonResponse == null) return;

		            //--- If the queue id from socket is not in the queue ids from url
                    if (!self.queueIds.includes(jsonResponse.queue.id)) return;

                    var queueIsOpen = self.checkIfExistsOpenCounter(jsonResponse);

                    //--- Check if queue id is inside global queues and and if there is not an open counter
                    if ( self.queues.find(queue => queue.queue.id == jsonResponse.queue.id) != null
                        && queueIsOpen != null && !queueIsOpen ) {
                        self.queues = $.grep(self.queues, obj => obj.queue.id != jsonResponse.queue.id);
                        self.prepareToRender(self.queues);
                        return;
                    }

                    //--- Check if queue id is not inside global queues and if there is an open counter
                    if ( self.queues.find(queue => queue.queue.id == jsonResponse.queue.id) == null
                        && queueIsOpen != null && queueIsOpen ) {
                       self.queues.push(jsonResponse);
                       self.prepareToRender(self.queues);
                       return;
                    }

                    //--- Check if there is only one queue COUNTER and if there is change in opened counters
                    if (jsonResponse.countersInfo && self.queues.length == 1 && self.queues[0].queue.type == "COUNTER") {
                        var prevOpenedCounters = self.getOpenedCounters(self.queues[0]);
                        var currentOpenedCounters = self.getOpenedCounters(jsonResponse);

                        if(prevOpenedCounters != currentOpenedCounters) {
                            self.queues = [];
                            self.queues.push(jsonResponse);
                            self.prepareToRender(self.queues);
                            return;
                        }

                    }

                    if (queueIsOpen == false) return;

                    if (jsonResponse.action) {
                        self.monitorView.updateLessInfo();

                        if (jsonResponse.soundData) {
                            self.playSound(jsonResponse);
                        }

                        return;
                    }

                    self.queues = self.queues.map(obj => {
                        if(obj.queue.id == jsonResponse.queue.id) return jsonResponse;
                        return obj;
                    });
		            self.monitorView.updateQueue(jsonResponse);

		        }catch(er) {
		            console.error("Error while parsing json ", er)
		        }
		    });

		    self.client.subscribe('/live/monitors/reload/', function (){
                location.reload();
            });
		});
	},
	clearListener: function() {
	    if(!this.client)
	        return;

		this.client.disconnect(function() {
		    console.log(i18n.t("queue.client_disconnected"));
		});
	},
	clearView: function() {
		this.clearListener();

	},
    isSamsungBrowser: function() {
        var ua = navigator.userAgent;
        var isSamsung = /SAMSUNG|Samsung|SGH-|GT-|SM-/i.test(ua);
        return isSamsung;
    },
	events:{

	},
	toggleLanguage: function() {
        var lang = i18n.lng();
        lang = lang == "el" ? "en" : "el";
        i18n.setLng(lang);

    },
	playSound: function(queueInfo) {

	    var queueThatNextWasCalled = $.grep(this.queues, function(queue, index) {
            return queue.queue.id === queueInfo.queue.id;
        });

        if(queueThatNextWasCalled && queueThatNextWasCalled.length == 1) {
            var callPatientData = {
                "timestamp": new Date(queueInfo.timestamp),
                "soundData":  queueInfo.soundData.substr(1)
            }

            this.callPatientBuffer.push(callPatientData);
            this.trigger("add:patientCall");
        }
	},
	checkIfExistsOpenCounter: function(queue) {
	    if (!queue.countersInfo) return null;

        var openedCounters = queue.countersInfo.filter(value => value.counter.status == "Open" );

        return openedCounters.length != 0;
	},
	checkIfOnlyOneCounterIsOpen: function(queue) {

	    return this.getOpenedCounters(queue).length == 1;
	},
	getOpenedCounters: function(queue) {
	    if (!queue.countersInfo) return 0;

	    return queue.countersInfo.filter(value => value.counter.status == "Open" );
	}
});

module.exports = TheView;